import { lazy, Suspense } from "react";
import LoadingFeedback from "@/components/shared/loading/LoadingFeedback";
import RouterErrorBoundary from "@/errors/RouterErrorBoundary/RouterErrorBoundary";

const EvaluationFormPage = lazy(() =>
  import("../pages/EvaluationFormPage")
);
const EvaluationForms = lazy(() => import("../pages/EvaluationForms"));

export const evaluationFormsRoutes = [
  {
    path: "/evaluation-form/:key",
    element: (
      <Suspense fallback={<LoadingFeedback />}>
        <EvaluationFormPage />
      </Suspense>
    ),
    errorElement: <RouterErrorBoundary />,
  },
];

export const evaluationFormsListRoutes = [
  {
    path: "/evaluation-forms",
    element: (
      <Suspense fallback={<LoadingFeedback />}>
        <EvaluationForms />
      </Suspense>
    ),
  },
];
